// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* GlobalPopupProvider — overlay + content animations */

/* ── Overlay (backdrop) ─────────────────────────────────── */
.scl--popup-overlay-context-global {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  
  opacity: 0;
  transition: opacity 220ms ease;
}

/* Backdrop fully visible */
.scl--popup-overlay-context-global.scl--popup-overlay--visible {
  opacity: 1;
}

/* Backdrop fading out */
.scl--popup-overlay-context-global.scl--popup-overlay--leaving {
  opacity: 0;
}

/* ── Modal content ──────────────────────────────────────── */
.scl--popup-content-context-global {
  background-color: #fff;
  border-radius: 4px;
  min-width: 300px;
  max-width: 90vw;

  opacity: 0;
  transition:
    opacity 220ms ease,
    transform 220ms cubic-bezier(0.22, 1, 0.36, 1);
}

/* Modal fully visible */
.scl--popup-content-context-global.scl--popup-content--visible {
  opacity: 1;
}

/* Modal leaving */
.scl--popup-content-context-global.scl--popup-content--leaving {
  opacity: 0;
  transition:
    opacity 220ms ease,
    transform 220ms ease;
}

/* ── Confirm layer — fixed to viewport, always above modal ── */
.scl--popup-confirm-layer {
  position: fixed;        /* escapes modal overflow:hidden */
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.45);
  z-index: 10000;         /* above overlay z-index: 99 */

  opacity: 0;
  transition: opacity 220ms ease;
}

.scl--popup-confirm-layer.scl--popup-confirm--visible  { opacity: 1; }
.scl--popup-confirm-layer.scl--popup-confirm--entering { opacity: 0; }
.scl--popup-confirm-layer.scl--popup-confirm--leaving  { opacity: 0; }`, "",{"version":3,"sources":["webpack://./src/context-controller-mod/context-serv/popup-provider/css/globalPopupProvider.css"],"names":[],"mappings":"AAAA,uDAAuD;;AAEvD,8DAA8D;AAC9D;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;;EAEb,UAAU;EACV,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,UAAU;AACZ;;AAEA,8DAA8D;AAC9D;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;;EAEf,UAAU;EACV;;kDAEgD;AAClD;;AAEA,wBAAwB;AACxB;EACE,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV;;wBAEsB;AACxB;;AAEA,gEAAgE;AAChE;EACE,eAAe,SAAS,kCAAkC;EAC1D,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,cAAc,UAAU,8BAA8B;;EAEtD,UAAU;EACV,8BAA8B;AAChC;;AAEA,yDAAyD,UAAU,EAAE;AACrE,yDAAyD,UAAU,EAAE;AACrE,yDAAyD,UAAU,EAAE","sourcesContent":["/* GlobalPopupProvider — overlay + content animations */\n\n/* ── Overlay (backdrop) ─────────────────────────────────── */\n.scl--popup-overlay-context-global {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  \n  opacity: 0;\n  transition: opacity 220ms ease;\n}\n\n/* Backdrop fully visible */\n.scl--popup-overlay-context-global.scl--popup-overlay--visible {\n  opacity: 1;\n}\n\n/* Backdrop fading out */\n.scl--popup-overlay-context-global.scl--popup-overlay--leaving {\n  opacity: 0;\n}\n\n/* ── Modal content ──────────────────────────────────────── */\n.scl--popup-content-context-global {\n  background-color: #fff;\n  border-radius: 4px;\n  min-width: 300px;\n  max-width: 90vw;\n\n  opacity: 0;\n  transition:\n    opacity 220ms ease,\n    transform 220ms cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n/* Modal fully visible */\n.scl--popup-content-context-global.scl--popup-content--visible {\n  opacity: 1;\n}\n\n/* Modal leaving */\n.scl--popup-content-context-global.scl--popup-content--leaving {\n  opacity: 0;\n  transition:\n    opacity 220ms ease,\n    transform 220ms ease;\n}\n\n/* ── Confirm layer — fixed to viewport, always above modal ── */\n.scl--popup-confirm-layer {\n  position: fixed;        /* escapes modal overflow:hidden */\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.45);\n  z-index: 10000;         /* above overlay z-index: 99 */\n\n  opacity: 0;\n  transition: opacity 220ms ease;\n}\n\n.scl--popup-confirm-layer.scl--popup-confirm--visible  { opacity: 1; }\n.scl--popup-confirm-layer.scl--popup-confirm--entering { opacity: 0; }\n.scl--popup-confirm-layer.scl--popup-confirm--leaving  { opacity: 0; }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
